module.exports = __webpack_public_path__ + "img/go-productpackaging-2.7347ba9c.png";